export const routes = {
  index: (venueId = ':venueId') => `/photo-shoot/${venueId}`,
  imagesSubmitted: (venueId = ':venueId') => `/photo-shoot/${venueId}/images-submitted`,
  imagesApproved: (venueId = ':venueId') => `/photo-shoot/${venueId}/images-approved`,
  linkExpired: (venueId = ':venueId') => `/photo-shoot/${venueId}/expired`,
};
